/*
export const SkuFoodParamTable = [
    {key: "id", name: "id", size: 50},
    {key: "week_number", name: "Номер недели", size: 50},
    {key: "start_date", name: "Начало", size: 50},
    {key: "end_date", name: "Конец", size: 50},
    {key: "store_name", name: "Магазин", size: 50},
    {key: "city", name: "Город", size: 50},
    {key: "sku", name: "Название", size: 50},
    {key: "link", name: "Ссылка", size: 50},
    {key: "level_1_samokat", name: "Левел 1(Самокат)", size: 50},
    {key: "level_2_samokat", name: "Левел 2(Самокат)", size: 50},
    {key: "level_3_samokat", name: "Левел 3(Самокат)", size: 50},
    {key: "category_1_level", name: "Категория (1 уровень)", size: 50},
    {key: "category_2_level", name: "Категория (2 уровень)", size: 50},
    {key: "category_3_level", name: "Категория (3 уровень)", size: 50},
    {key: "segment_price", name: "Сегмент цены", size: 50},
    {key: "address", name: "Адрес", size: 50},
    {key: "large_serving", name: "large_serving", size: 50},
    {key: "manufacturer", name: "manufacturer", size: 50},
    {key: "price_vit", name: "Цена витрина", size: 50},
    {key: "price_sale", name: "Цена скидка", size: 50},
    {key: "unic", name: "unic", size: 50},
    {key: "quantity", name: "quantity", size: 50},
]*/

export const SkuFoodParamTable: {[key: string]: {name: string, size: number}} = {
    "id":  {name: "id", size: 100},
    "week_number": {name: "Номер недели", size: 50},
    "start_date": {name: "Начало", size: 50},
    "end_date": {name: "Конец", size: 50},
    "store_name": {name: "Магазин", size: 150},
    "city": {name: "Город", size: 100},
    "sku": {name: "Название", size: 200},
    "link": {name: "Ссылка", size: 50},
    "level_1_samokat": {name: "Левел 1(Самокат)", size: 150},
    "level_2_samokat": {name: "Левел 2(Самокат)", size: 50},
    "level_3_samokat": {name: "Левел 3(Самокат)", size: 100},
    "category_1_level": {name: "Категория (1 уровень)", size: 100},
    "category_2_level": {name: "Категория (2 уровень)", size: 100},
    "category_3_level": {name: "Категория (3 уровень)", size: 100},
    "segment_price": {name: "Сегмент цены", size: 100},
    "address": {name: "Адрес", size: 200},
    "large_serving": {name: "Большая порция", size: 50},
    "manufacturer": {name: "Производство", size: 50},
    "price_vit": {name: "Цена витрина", size: 50},
    "price_sale": {name: "Цена скидка", size: 50},
    "unic": {name: "Уникальность", size: 100},
    'unic_status': {name: "unic_status", size: 50},
    "quantity": {name: "Количество", size: 50},
}




